import { ISurgery } from './Surgary.types';

export const initialSurgery : ISurgery = {
  date: null,
  type: ""
}